import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocSessionQuery,
  betterDocSessionQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocSessionQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query betterDocSessionQuery($sessionId: Int!) {
    de_betterDocSession(sessionId: $sessionId) {
      session {
        sessionId
        partnerSessionId
        partnerPatientId
        progressNoteId
        isTestCase
        testCaseScenario
        navigationType
        insuranceCountry
        betterDocState
        recommendationId
        caseId
        createdAt
        createdBy
        updatedAt
      }
      steps {
        stepId
        occurredAt
        type
        betterDocState
        isUnchanged
        actor
        exchangeId
        detail
      }
      recommendedMedics {
        recommendedMedicId
        position
        selectionId
        payload
        receivedInExchangeId
        receivedAt
      }
      exchanges {
        exchangeId
        operation
        actor
        httpMethod
        requestUri
        isTestCase
        hasUnexpectedResponse
        responseStatusCode
        durationMilliseconds
        startedAt
        outcome
        failureKind
      }
    }
  }
`

export type BetterDocSessionDetail = NonNullable<betterDocSessionQuery$data["de_betterDocSession"]>

export type BetterDocSessionSummary = BetterDocSessionDetail["session"]

export type BetterDocSessionStep = BetterDocSessionDetail["steps"][number]

export type BetterDocRecommendedMedic = BetterDocSessionDetail["recommendedMedics"][number]

export type BetterDocExchangeSummary = BetterDocSessionDetail["exchanges"][number]

export const fetchBetterDocSession = (sessionId: number): Promise<BetterDocSessionDetail | null> =>
  fetchQuery<betterDocSessionQuery>(RelayEnvironment, query, { sessionId }, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => response?.de_betterDocSession ?? null)
